import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUser } from '../../contexts/UserContext';
import AccueilPage from "../../pages/Accueil/AccueilPage";
import Routing from "../../services/routing";

const RedirectBasedOnUser = () => {
    const { user } = useUser();
    const location = useLocation();

    if (!user) {
        return <Navigate to={Routing.routes.login} replace state={{ from: location }} />;
    } else if (user.status !== 1) {
        const link = `/userstatus`;
        return <Navigate to={link} replace />;
    } else {
        return <AccueilPage />;
    }
};

export default RedirectBasedOnUser;
